class GoogleMapService {
    constructor(settingsService, googleMapsApi) {
        this.settingsService = settingsService;
        this.googleMapsApi = googleMapsApi;
    }

    loadMap() {
        return this.settingsService.getSettingValue('StoreLocator', 'StoreLocatorGoogleMapApiURL')
            .then(this.googleMapsApi)
            .then((googleApi) => {
                window.google = googleApi;
            });
    }

    loadMapWithCallback(callback) {
        return this.settingsService.getSettingValue('StoreLocator', 'StoreLocatorGoogleMapApiURL')
            .then(this.googleMapsApi)
            .then((googleApi) => {
                window.google = googleApi;
                callback();
            });
    }
}

module.exports = GoogleMapService;



// WEBPACK FOOTER //
// ./src/olycommon/googlemaps/google-map.service.js